import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div className="p-3">{children}</div>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabCompo({ tabArray }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="w-full">
      <div className="w-auto">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="full width tabs example"
            >
              {tabArray?.map((e, i) => (
                <Tab label={e?.title} {...a11yProps(i)} key={i} />
              ))}
            </Tabs>
      </div>
      {tabArray?.map((e, i) => (
        <CustomTabPanel value={value} index={i} key={i}>
          {e?.component}
        </CustomTabPanel>
      ))}
    </div>
  );
}

export default TabCompo;
